type Params = {
  [key: string]: string | string[]
}

export const checkIsMobileApp = (params: Params): boolean => {
  let isMobileApp = params?.['isMobileApp']

  if (Array.isArray(isMobileApp)) {
    isMobileApp = isMobileApp[0]
  }

  // URL search parametresini de kontrol et
  if (globalThis.window !== undefined && !isMobileApp) {
    const urlParams = new URLSearchParams(globalThis.window.location.search)
    const urlIsMobileApp = urlParams.get('isMobileApp')
    if (urlIsMobileApp === '1') {
      return true
    }
  }

  return isMobileApp === '1'
}
